
import { ApiError } from './ApiError';
import { ValidationError } from './ValidationError';
import { NotFoundError } from './NotFoundError';
import { type ValidationProblemDetails, type ProblemDetails } from '../../types/error.types';

const isProblemDetails = (value: unknown): value is ProblemDetails => {

    if (typeof value !== "object" || value === null) {
        return false;
    }
    const obj = value as Record<string, unknown>;
    return "status" in obj || "title" in obj || "detail" in obj;
}

const isValidationProblemDetails = (
    value: unknown
): value is ValidationProblemDetails => {

    if (!isProblemDetails(value)) {
        return false;
    }
    const obj = value as Record<string, unknown>;
    return "errors" in obj;
}

export const mapApiError = (payload: unknown): Error => {

    if (isValidationProblemDetails(payload)) {
        return new ValidationError(payload);
    }

    if (!isProblemDetails(payload)) {
        return new Error("Unexpected API error");
    }

    const map: Record<number, (p: ProblemDetails) => Error> = {
        404: p => new NotFoundError(p),
    };

    const factory = payload.status ? map[payload.status] : undefined;
    return factory ? factory(payload) : new ApiError(payload);
}